import { Entity } from '@api';
import { ChartAssetData } from '@chart';
import { Alert, AlertType } from '@design/components/alert/Alert';
import { cryptoRandom } from '@helpers';
import { ToastPosition, useToasts } from '@terminal/stores/use-toasts/useToasts';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface UseChartErrorsProps {
  chartData: ChartAssetData[];
}

export const useChartErrors = ({ chartData }: UseChartErrorsProps) => {
  const { t } = useTranslation('chart');
  const { showToast, removeToast } = useToasts(
    ({ showToast, removeToast }) => ({
      showToast,
      removeToast,
    })
  );
  const [hasError, setHasError] = useState(false);
  const [hasEmpty, setHasEmpty] = useState(false);
  const [assetWithError, setAssetWithError] = useState<Entity>();

  const handleEmptyChart = (bannerLabel: string) => {
    setHasEmpty(true);

    if (chartData.length > 0) {
      const toastId = cryptoRandom();
      showToast({
        id: toastId,
        scope: 'chart',
        position: ToastPosition.TopRight,
        content: (
          <Alert
            type={AlertType.Warning}
            title={t('chart:widget.emptyBannerTitle', {
              label: bannerLabel,
            })}
            onClose={() => {
              removeToast(toastId);
            }}
          />
        ),
      });
    }
  };

  return {
    chartError: {
      assetWithError,
      setAssetWithError,
      hasError,
      setHasError,
      hasEmpty,
      setHasEmpty,
      handleEmptyChart,
    },
  };
};
